import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const NoAccessPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate("/");
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100vh",
                padding: 3,
            }}
        >
            <Typography variant="h4" component="h1" align="center" sx={{ mb: 4 }}>
                {t("page.noAccessPage.title")}
            </Typography>
            <Button variant="contained" onClick={handleGoBack}>
                {t("page.sales_landing_page.return")}
            </Button>
        </Box>
    );
};
